import axios from 'axios';
import * as types from '../constants/ActionTypes';

// Redirect to ICF page by icdId

// Event handler when user clicks one of the FAQ item
const expandFAQContent = (articleId, icfId) => ({ type: types.EXPAND_FAQ_CONTENT, payload: { articleId, icfId } });

const icfClicked = icfId => ({
  type: types.ICF_SELECTED,
  payload: icfId,
});

const updateVisitedICFAccessList = payload => ({ type: types.UPDATE_VISITED_ACCESS_LIST, payload });

const requestSetICFAccessedArticle = () => ({ type: types.REQUEST_SET_ICF_ACCESSED_ARTICLE });

const receivedSetICFAccessedArticle = payload => ({ type: types.RECEIVED_SET_ICF_ACCESSED_ARTICLE, payload });

const receviedSetICFAccessedArticleError = () => ({ type: types.RECEIVED_SET_ICF_ACCESSED_ARTICLE_ERROR });

const setICFAccessArticle = (icfId, faqId) => (dispatch) => {
  dispatch(requestSetICFAccessedArticle());
  return axios.get(`/smarthelp/set-icf-visit?icfId=${icfId}&faqId=${faqId}`)
    .then((response) => {
      dispatch(receivedSetICFAccessedArticle(response.data));
    })
    .catch(() => {
      dispatch(receviedSetICFAccessedArticleError());
    });
};

const requestGetICFAccessedArticle = () => ({ type: types.REQUEST_GET_ICF_ACCESSED_ARTICLE });

const receviedGetICFAccessedArticleError = () => ({ type: types.RECEIVED_GET_ICF_ACCESSED_ARTICLE_ERROR });

const getICFAccessdArticle = () => (dispatch) => {
  dispatch(requestGetICFAccessedArticle());
  return axios.get('/smarthelp/get-icf-visit')
    .then((response) => {
      dispatch(updateVisitedICFAccessList(response.data && response.data.icfAccessedList));
    })
    .catch(() => {
      dispatch(receviedGetICFAccessedArticleError());
    });
};

module.exports = {
  expandFAQContent,
  icfClicked,
  setICFAccessArticle,
  getICFAccessdArticle,
};
